/*global define */

define(function (require, exports) {
    'use strict';

    var CONTENT_REF_PREF = 'contentRef';
    var LINK_BASE_PREF = 'linkBase';
    var TEMPLATE_NAME = 'templateName';

    var initDesignMode = function (ctrl, lpWidget) {
        ctrl.saveContentRef = function (contentRef) {
            lpWidget.setPreference(CONTENT_REF_PREF, contentRef);
            lpWidget.model.save(function () {
                lpWidget.refreshHTML();
            });
        };
    };

    /**
     * Structured Content Controller
     * @ngInject
     */

    exports.MainCtrl = function ($location, lpContentUtils, lpWidget, lpPortal, lpCoreI18n, lpCoreBus, lpCoreI18nUtils) {
        var ctrl = this;
        var contentRef = lpWidget.getPreference(CONTENT_REF_PREF);
        var asyncContentRef = $location.url().replace(/^\//, '');
        var linkBase = lpWidget.getPreference(LINK_BASE_PREF);
        var templateName = lpWidget.getPreference(TEMPLATE_NAME);

        ctrl.isMobileNative = lpWidget.getPreference('native') || false;

        ctrl.initContentRef = contentRef;
        if (asyncContentRef !== contentRef) {
            ctrl.asyncContentRef = asyncContentRef;
        }

        if (templateName == 'contact' || templateName == 'register') {
            $(lpWidget.htmlNode).closest(".pageContainer").addClass('page-grey-background');
            $(lpWidget.htmlNode).closest("html").addClass('page-grey-background');

            if (templateName == 'register') {

                if ($(".download-links").find("a:not([href])").length > 0) {
                    $(".download-links").find("a:not([href])").hide();
                    $(".download-links a:nth-child(2)").css("padding-left", "0");
                }
				//$($(".register-content .box .download-links")[5]).css("color", '#1281ab');
                //$($(".register-content .box .download-links")[2]).css("color", '#1281ab');
                //$($($($(".register-content .box .download-links")[2]).find("a"))[0]).css("border","none");
                //$($($($(".register-content .box .download-links")[2]).find("a"))[1]).hide();
                /*if (window.sessionStorage.getItem("selected_locale") == 'en-US') {
                    $($(".register-content .box .download-links")[5]).html("Coming soon");
                }
                else {
                    $($(".register-content .box .download-links")[5]).html("Bientôt disponible");
                }*/


            }
            setLocalization(window.sessionStorage.getItem("selected_locale"));
        }
        else if (templateName == 'terms') {
            var data = {
                englishTerms: $(lpWidget.htmlNode).find(".english-terms").html(),
                frenchTerms: $(lpWidget.htmlNode).find(".french-terms").html(),
                arabicTerms: $(lpWidget.htmlNode).find(".arabic-terms").html(),
            };
            lpCoreBus.publish('launchpad-retail.termsAndConditionsContent', data);
        }

        function setLocalization(locale) {
            if (locale == 'en-US') {
                $(".transalte-fr").hide();
                $(".transalte-en").show();
            }
            else if (locale == 'fr-FR') {
                $(".transalte-en").hide();
                $(".transalte-fr").show();
            }
            $.getJSON(lpWidget.myDefinition.sUrl.replace("index.html", "locale/all.json"), function (data) {
                $(".contact-data").text(data[locale]["abc.contact.footer"]);
                $(".legal-notes").text(data[locale]["abc.contact.legal.note"]);
                $(".translate-register-as").text(data[locale]["abc.register.as"]);
                $(".translate-retail-customer").text(data[locale]["abc.register.retail.customer"]);
                $(".translate-corporate-customer").text(data[locale]["abc.register.corporate.customer"]);
            });
            if ($(".register-content .box .download-links").length > 0) {
                //$($($($(".register-content .box .download-links")[2]).find("a"))[0]).css("border","none");
                //$($($($(".register-content .box .download-links")[2]).find("a"))[1]).hide();
                /*if (locale == 'en-US') {
                    $($(".register-content .box .download-links")[5]).html("Coming soon");
                }
                else {
                    $($(".register-content .box .download-links")[5]).html("Bientôt disponible");
                }*/
            }
        }

        lpCoreBus.subscribe(lpCoreI18nUtils.LOCALE_CHANGE_EVENT, function (locale) {
            setLocalization(locale);
        });

        if (linkBase) {
            ctrl.link = lpPortal.root + '/' + linkBase + '#/' + contentRef;
            $(lpWidget.htmlNode).find('.media a.media-link').attr('href', ctrl.link);
            $(lpWidget.htmlNode).find('.media a.media-link-small').attr('href', ctrl.link);
        }

        if (lpContentUtils.isEditable(lpWidget)) {
            initDesignMode(ctrl, lpWidget);
        }

        var acc = $(lpWidget.htmlNode).find(".accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].onclick = function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.display === "block") {
                    panel.style.display = "none";
                } else {
                    panel.style.display = "block";
                }
            };
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/controllers.js
// module id = 7
// module chunks = 0